const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".shopify-block:has(.bss-b2b-vat-input-wrapper)");
    const footerPrice = document.querySelector(".cart-drawer__body");
    
    if (footerPrice && vatInputWrapper) {
 footerPrice.parentNode.insertBefore(vatInputWrapper, footerPrice.nextSibling);
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(".shopify-block:has(.bss-b2b-vat-input-wrapper)");
    const footerPrice = document.querySelector(".cart__summary .cart__summary-actions");
    if (vatInputWrapper) {
     footerPrice.parentNode.insertBefore(vatInputWrapper, footerPrice);
        clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}



// compatible cart slider qikify



  async function search() {
        const productTitles = [];
        const nameproductEle = document.querySelectorAll('.eascRecoRow  .easc-recoTitle')
        if (nameproductEle.length) {
            nameproductEle.forEach(element => {
                productTitles.push(element.innerHTML);
            });
        }
        const productPromises = productTitles.map(productTitle => {
            return fetch('/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product')
                .then(response => response.json())
                .then(data => {
                    if (data?.resources?.results?.products?.length > 0) {
                        return {
                            title: productTitle,
                            productId: data.resources.results.products[0].id
                        };
                    } else {
                        return {
                            title: productTitle,
                            productId: null,
                            message: 'No product found'
                        };
                    }
                })
                .catch(error => {
                    return {
                        title: productTitle,
                        productId: null,
                        error: 'Error fetching product data: ' + error
                    };
                });
        });

        const results = await Promise.all(productPromises);
        let sub = 0 
        results.forEach(result => {
            if (result.productId) {
                nameproductEle.forEach(element => {
                    if (element.innerHTML == result.title && !element.hasAttribute('bss-b2b-product-id')) {
                        let card = element.closest(' .easc-prodRowTitle')
                        let price = card.querySelector('.easc-prodRowPrice')
                        let variantID = card.getAttribute('data-variant-id')
                        
                        if (price) {
                            price.setAttribute('bss-b2b-product-id', result.productId)
                            price.setAttribute('bss-b2b-product-price', '')
                        }
                    }
                });
            } else {
                console.log(`⚠️ Product Title: ${result.title} - Error: ${result.message || result.error}`);
            }
        });
        return results;
        
    }

const config = {
  selectorCard: '#qikify-stickycart-v2-app .qsc2-product-item-wrapper',
  selectorOriginPrice: '.easc-prodRowTitle .prodRowPrice',
  selectorFinalLinePrice: '.easc-prodRowPrice',
  selectorSubtotalPrice: '.easc-miniCartProductsDiv .eascCartSubtotal .prodRowPrice', 
};


// async function addCartPriceAttributes(config) {
//   const AjaxCartApi = window.BSS_B2B?.utils?.AjaxCartApi;
//   if (!AjaxCartApi) return;

//   let lineItems = [];
//   try {
//     const res = await AjaxCartApi.getCart();
//     lineItems = res.items || [];
//   } catch (err) {
//     window.BSS_B2B?.logger?.error?.('[BSS B2B] Failed to fetch cart.js:', err);
//     return;
//   }
//     setTimeout( async ()=>{
//   let pridPrice =  document.querySelector('.eascRecoRow.eascRecoRowBox ')
//   if (pridPrice) {
//      await search()
//   }
//    const res = await BSS_B2B.storage.productStorage.load();
//                     if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
//                         await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
//                             ...res,
//                         });
//                     }
//   },1000)

//   const cartItems = document.querySelectorAll('.eascProdBox .easc-productRow');
//   cartItems.forEach((item) => {
//     const link = item.querySelector('.easc-prodImage');
//     const href = link?.getAttribute('src');
//     if (!href || item.hasAttribute('bss-b2b-cart-item-key')) return;

//     const finalEls = config.selectorFinalLinePrice
//       ? Array.from(item.querySelectorAll(config.selectorFinalLinePrice))
//       : [];

//     const productMatch = lineItems.find((p) =>
//       href.includes(p.image.toString())
//     );
  
//     const itemKey = productMatch?.key;
//     console.log("itemKey:", itemKey);
//     if (itemKey) item.setAttribute('bss-b2b-cart-item-key', itemKey);

//     finalEls.forEach((el) => {
//       el.setAttribute('bss-b2b-item-original-price', '');
//       if (itemKey) el.setAttribute('bss-b2b-cart-item-key', itemKey);
//     });
//   });

//   const totalPrice = document.querySelector('.d-flex.easc-subtotalDiscIcon');
//   if (totalPrice && !totalPrice.hasAttribute('bss-b2b-cart-total-price')) {
//     totalPrice.setAttribute('bss-b2b-cart-total-price', '');
//   }
// }

// function observeMiniCartRepeatedly() {
//   const targetSelector = '.easc-miniCartProductsDiv';

//   const mainObserver = new MutationObserver(() => {
//     const miniCart = document.querySelector(targetSelector);
//     if (miniCart && !miniCart.dataset.bssB2bProcessed) {
//       console.log('[MiniCart] Mini cart mới xuất hiện.');
//       miniCart.dataset.bssB2bProcessed = 'true';

//       addCartPriceAttributes(config).then(() => {
//         window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');

//         const cartContainer = document.querySelector('.eascProdBox');
//         if (cartContainer) {
//           const cartItemsObserver = new MutationObserver((mutations) => {
//             for (const mutation of mutations) {
//               if (mutation.addedNodes.length > 0) {
//                 console.log('[MiniCart] Item mới được thêm vào → xử lý lại.');
//                 addCartPriceAttributes(config);
//                 window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');
//               }
//             }
//           });

//           cartItemsObserver.observe(cartContainer, {
//             childList: true,
//             subtree: false, // bạn có thể bật true nếu cần lắng cả con cháu sâu
//           });
//         }
//       });
//     }
//   });

//   mainObserver.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });
// }

// document.addEventListener('DOMContentLoaded', observeMiniCartRepeatedly);






 document.addEventListener("DOMContentLoaded", function() {
     let input = document.querySelectorAll('.cart-item__quantity select.quantity__select')
     input.forEach((e) => {
         e.addEventListener('change', () => {
             setTimeout(() => {
                 BSS_B2B.observer.cartSubject.listenCartCheckout();
             }, 1500)
         })
     })



     let searchDrawer = document.querySelector('cart-items');
     if (searchDrawer) {
         let observer = new MutationObserver(function(mutations) {
             mutations.forEach(function(m) {
                 if (m.addedNodes.length) {
                     BSS_B2B.observer.cartSubject.listenCartCheckout();
                 }
             });
         });
         observer.observe(searchDrawer, {
             childList: true
         });
     }
     let variantClick = document.querySelectorAll('li[bss-b2b-variant-click]')
     if (variantClick.length) {
      variantClick.forEach((e)=>{
        e.addEventListener('click', ()=>{
          setTimeout(() => {
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }, 1000);
        })
      })
     }

 });

 document.addEventListener('cart:rerendered', () => {
     if (BSS_B2B) {
         setTimeout(() => {
             BSS_B2B.observer.cartSubject.listenCartCheckout();
         }, 1500)

     }
 })